import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { knowledgeApi } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Loader2, ArrowLeft, BookOpen, Eye } from 'lucide-react';

export default function ArticleViewPage() {
  const { idOrSlug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    knowledgeApi.getArticle(idOrSlug)
      .then(({ data }) => setArticle(data))
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [idOrSlug]);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#0E7490]" /></div>;
  if (!article) return <div className="p-8 text-center text-[#64748B]">Article not found.</div>;

  return (
    <div className="max-w-4xl mx-auto space-y-4" data-testid="article-view-page">
      <Button variant="ghost" size="sm" onClick={() => navigate('/knowledge')} data-testid="back-to-kb-btn"><ArrowLeft className="w-4 h-4 mr-1" />Back to Knowledge Base</Button>

      {article.featured_image_url && (
        <img src={article.featured_image_url} alt="" className="w-full max-h-72 object-cover rounded-lg" />
      )}

      <Card className="careiq-card">
        <CardContent className="p-6 space-y-3">
          <div className="flex items-center gap-2 text-xs text-[#64748B]">
            <BookOpen className="w-4 h-4 text-[#0E7490]" />
            <span>{article.author_name || '—'}</span>
            <span>·</span>
            <span>{new Date(article.created_at).toLocaleDateString()}</span>
            <span>·</span>
            <span className="flex items-center gap-1"><Eye className="w-3 h-3" />{article.view_count}</span>
          </div>
          <h1 className="text-3xl font-bold text-[#0A2342]" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="article-title">{article.title}</h1>
          {article.summary && <p className="text-[#64748B]">{article.summary}</p>}
          <div className="flex flex-wrap gap-1 pb-3 border-b border-[#E2E8F0]">
            {(article.tags || []).map(t => <Badge key={t} className="bg-[#F1F5F9] text-[#64748B]">{t}</Badge>)}
          </div>
          <div
            className="prose prose-sm md:prose-base max-w-none [&_iframe]:w-full [&_iframe]:aspect-video [&_iframe]:rounded-lg [&_img]:rounded-lg [&_a]:text-[#0E7490] [&_a]:underline"
            dangerouslySetInnerHTML={{ __html: article.content_html || '' }}
            data-testid="article-content"
          />
        </CardContent>
      </Card>
    </div>
  );
}
